import { SYS_ID_MODES } from './sysIdMode';

export const shouldDeleteLocation = (switches, sysIdMode) =>
  sysIdMode === SYS_ID_MODES.EDIT &&
  (switches ?? []).flat().filter(Boolean).length === 0;
